import { render } from "./QuestaoSelecaoEdicao.vue?vue&type=template&id=84fdecc0&scoped=true&ts=true"
import script from "./QuestaoSelecaoEdicao.vue?vue&type=script&lang=ts"
export * from "./QuestaoSelecaoEdicao.vue?vue&type=script&lang=ts"

import "./QuestaoSelecaoEdicao.vue?vue&type=style&index=0&id=84fdecc0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fdecc0"]])

export default __exports__